import React, { useEffect, useState } from 'react'
import { ParticipationReportSlideoutHeader } from './ParticipationReportSlideoutHeader';
import { SurveysCard } from './SurveysCard';
import { ParticipationsReportCard } from './ParticipationReportsCard';
import { ParticipationReportSlideoutFooter } from './ParticipationReportSlideoutFooter';
import { ParticipationReport, Survey } from './types';
import { IAppState } from '@/src/js/lib/types';
import { useSelector } from 'react-redux';
import './ParticipationReportSlideout.scss'

const ParticipationReportSlideout = () => {
    const [selectedSurvey, setSelectedSurvey] = useState<Survey | undefined>()
    const [selectedReport, setSelectedReport] = useState<ParticipationReport | undefined>()
    const slideout = useSelector((state: IAppState) => state.slideout)

    useEffect(() => {
        setSelectedSurvey(undefined)
        setSelectedSurvey(undefined)
    }, [slideout.open])

    if (!slideout.open) return null

    return (
        <div className='pcenter-slideout__container'>
            <ParticipationReportSlideoutHeader />
            <div className='pcenter-slideout__body'>
                <SurveysCard selectedSurvey={selectedSurvey} setSelectedSurvey={setSelectedSurvey} setSelectedReport={setSelectedReport} />
                <ParticipationsReportCard selectedReport={selectedReport} setSelectedReport={setSelectedReport} selectedSurvey={selectedSurvey} />
            </div>
            <ParticipationReportSlideoutFooter selectedReport={selectedReport} setSelectedReport={setSelectedReport} setSelectedSurvey={setSelectedSurvey} />
        </div>
    )
}

export default ParticipationReportSlideout